import { AlertTriangle, Eye, Hand, Users, Phone } from 'lucide-react';

const EmergencyTips = () => {
  const tips = [
    {
      icon: Eye,
      title: 'Stay Calm & Observe',
      description: 'Keep a safe distance of at least 6 feet. Note the snake\'s location and try to identify it if possible.',
    },
    {
      icon: Hand,
      title: 'Don\'t Attack or Provoke',
      description: 'Never try to kill or catch the snake yourself. Most bites happen when people try to handle snakes.',
    },
    {
      icon: Users,
      title: 'Keep Children & Pets Away',
      description: 'Immediately move children and pets to a safe area. Block the room if the snake is indoors.',
    },
    {
      icon: Phone,
      title: 'Call the Expert Immediately',
      description: 'Contact a professional snake rescuer right away. Keep watching the snake until help arrives.',
    },
  ];

  return (
    <section 
      id="emergency-tips"
      className="py-20 md:py-32 bg-[#1A2C20]"
      data-testid="emergency-tips-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#D9534F]/20 border border-[#D9534F]/40 rounded-full px-4 py-2 mb-6">
            <AlertTriangle className="w-4 h-4 text-[#D9534F]" />
            <span className="text-[#D9534F] text-sm font-semibold">Snake Emergency Help</span>
          </div>
          <h2 
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#F5F3ED] mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="emergency-tips-heading"
          >
            Snake In House? Here's What To Do
          </h2>
          <p className="text-[#B8C4BA] text-lg max-w-2xl mx-auto">
            Found a <strong>snake inside house</strong>? Follow these crucial steps while waiting for the <strong>snake catcher near me</strong>
          </p>
        </div>

        {/* Tips Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {tips.map((tip, index) => {
            const IconComponent = tip.icon;
            return (
              <div 
                key={index}
                className="bg-[#243A2B] border border-[#2A4B35] rounded-2xl p-6 hover:border-[#25D366]/50 transition-all duration-300"
                data-testid={`emergency-tip-${index + 1}`}
              >
                <div className="w-12 h-12 bg-[#2A4B35] rounded-xl flex items-center justify-center mb-4">
                  <IconComponent className="w-6 h-6 text-[#25D366]" />
                </div>
                <h3 
                  className="text-lg font-semibold text-[#F5F3ED] mb-2"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  {tip.title}
                </h3>
                <p className="text-[#9CA89F] text-sm leading-relaxed">
                  {tip.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Emergency CTA */}
        <div className="mt-12 text-center">
          <p className="text-[#9CA89F] mb-4">Call our expert team immediately:</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a 
              href="tel:+918310755854"
              className="inline-flex items-center gap-3 bg-[#D9534F] hover:bg-[#c9433f] text-white font-bold px-6 py-3 rounded-full emergency-pulse transition-all"
              data-testid="emergency-tips-call-btn-1"
            >
              <Phone className="w-5 h-5" />
              Alhan: +91 8310755854
            </a>
            <a 
              href="tel:+919845080903"
              className="inline-flex items-center gap-3 bg-[#D9534F] hover:bg-[#c9433f] text-white font-bold px-6 py-3 rounded-full emergency-pulse transition-all"
              data-testid="emergency-tips-call-btn-2"
            >
              <Phone className="w-5 h-5" />
              Mohan: +91 9845080903
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmergencyTips;
